const STATUS_CONFIG = {
  DONE: { icon: "✓", color: "#15803D" },
  RETURNED: { icon: "↩", color: "#C2410C" },
  IN_PROGRESS: { icon: "●", color: "#4F46E5" },
  SUBMITTED: { icon: "📤", color: "#A16207" },
  PENDING: { icon: "○", color: "#9CA3AF" },
  SKIPPED: { icon: "⊘", color: "#D1D5DB" },
  REJECTED: { icon: "↺", color: "#B45309" },
  REASSIGNED: { icon: "🔄", color: "#6B7280" },
  REMOVED: { icon: "✕", color: "#6B7280" },
};

export default function ProjectStageListItem({
  stage,
  status,
  assigneeNames = [],
  isSelected,
  isCurrent,
  graphState,
  waitingOn = [],
  needsAssignee,
  isJoin,
  onClick,
}) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.PENDING;
  const isBlocked = graphState === "BLOCKED" && waitingOn.length > 0;
  const waitingNames = waitingOn.map((item) => item.stageName).join(", ");

  const title = [
    stage.name,
    assigneeNames.length ? `— ${assigneeNames.join(", ")}` : "",
    isBlocked ? `— waiting on ${waitingNames}` : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      className={[
        "stage-list-item",
        isSelected ? "stage-list-item--selected" : "",
        isCurrent ? "stage-list-item--current" : "",
        isBlocked ? "stage-list-item--blocked" : "",
        needsAssignee ? "stage-list-item--needs-assignee" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={onClick}
      title={title}
    >
      <span className="stage-list-icon" style={{ color: config.color }}>
        {isBlocked ? "⏸" : config.icon}
      </span>
      <div className="stage-list-info">
        <span className="stage-list-name">
          {isJoin && <span className="stage-join-marker" title="Join — waits for every incoming branch">◆</span>}
          {stage.name}
        </span>

        {assigneeNames.length > 0 && (
          <span className="stage-list-assignee">{assigneeNames.join(", ")}</span>
        )}

        {needsAssignee && (
          <span className="stage-list-flag stage-list-flag--unassigned">
            Unassigned
          </span>
        )}

        {isBlocked && (
          <span className="stage-list-flag stage-list-flag--waiting">
            Waiting on {waitingNames}
          </span>
        )}
      </div>
      {isCurrent && <span className="stage-list-dot" />}
    </button>
  );
}
